import "./authLayout.css";

const AuthLayout = ({ renderItem }) => (
  <div className="auth-container">
    <div className="left-block">{renderItem()}</div>
    <div className="right-block">
      <img src="/sigin-bg.png" alt="" />
    </div>
  </div>
);

export default AuthLayout;
